export const ROUTE_PATHS = {
  HOME: '/',
  SERVICES: '/services',
  ABOUT: '/about',
  CONTACT: '/contact',
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  price: string;
  duration: string;
  features: string[];
  imageUrl: string;
}

export interface TeamMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  imageUrl: string;
  specialties: string[];
}

export interface Testimonial {
  id: string;
  clientName: string;
  dogName: string;
  dogBreed: string;
  rating: number;
  comment: string;
  imageUrl: string;
}

export const formatPrice = (price: string): string => {
  return price.startsWith('$') ? price : `$${price}`;
};

export const formatDuration = (duration: string): string => {
  return duration.toLowerCase().includes('hour') || duration.toLowerCase().includes('min') 
    ? duration 
    : `${duration} hours`;
};
